import axios from 'axios';

export default {
  fetchVisits(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/visits", {params})
      .then(results=>{
        return results.data;
      })
  },
  getVisit(visitId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/visits/${visitId}`)
      .then(results=>{
        return results.data;
      })
  },
  updateVisit(visitId, visitInfo){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/visits/${visitId}`, visitInfo)
      .then(results=>{
        return results.data;
      })
  },
  createVisit(visitInfo){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/visits`, visitInfo)
      .then(results=>{
        return results.data;
      })
  },
  deleteVisit(visitId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/v1/admin/visits/${visitId}`)
      .then(results=>{
        return results.data;
      })
  },
}
